import React, { useState, useEffect, useCallback } from "react";
import API from "../utils/API";
let logoutTimer;
const AuthContext = React.createContext({
  token: "",
  isLoggedIn: false,
  user: null,
  login: (token) => {},
  logout: () => {},
});

const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();

  const remainingDuration = adjExpirationTime - currentTime;

  return remainingDuration;
};
const retrieveStordToken = () => {
  const storedToken = localStorage.getItem("token");
  const userToken = localStorage.getItem("user");
  const storedExpirationDate = localStorage.getItem("expirationTime");

  const remainingTime = calculateRemainingTime(storedExpirationDate);

  if (remainingTime <= 60000) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("expirationTime");
    localStorage.removeItem("searchQuery");
    localStorage.removeItem("usersResult");
    return null;
  }

  return {
    token: storedToken,
    user: userToken,
    duration: remainingTime,
  };
};

export const AuthContextProvider = (props) => {
  const tokenData = retrieveStordToken();
  let initialToken, initialUser;
  if (tokenData) {
    initialToken = tokenData.token;
    initialUser = tokenData.user;
  }
  const [token, setToken] = useState(initialToken);
  const [user, setUser] = useState(initialUser);

  const userIsloggedIn = !!token;

  async function LogOut() {
    const token = localStorage.getItem("token");

    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      await API.get("/logout", config);
    } catch (error) {
      console.log(error);
    }
  }

  const logoutHandler = useCallback(() => {
    LogOut();
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("expirationTime");
    localStorage.removeItem("searchQuery");
    localStorage.removeItem("usersResult");
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  const loginHandler = (token, user, expirationTime) => {
    setToken(token);
    setUser(user);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", token);
    localStorage.setItem("expirationTime", expirationTime);

    const remainingTime = calculateRemainingTime(expirationTime);
    logoutTimer = setTimeout(logoutHandler, remainingTime);
  };

  useEffect(() => {
    if (tokenData) {
      logoutTimer = setTimeout(logoutHandler, tokenData.duration);
    }
  }, [tokenData, logoutHandler]);

  const contextValue = {
    token: token,
    isLoggedIn: userIsloggedIn,
    user: user,
    login: loginHandler,
    logout: logoutHandler,
  };
  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
